export const formatNumberInput = (amount: string) =>
  amount.replace(/[^0-9]/g, '');

export const formatPourcentage = (amount: string) => {
  let updatedAmount = amount.replace(',', '.');
  if (Number(updatedAmount) > 100 || Number(updatedAmount) < 0) return 0;
  return amount === '' ? '' : Number(updatedAmount);
};
